import { render, staticRenderFns } from "./WorkoutTypes.vue?vue&type=template&id=0b21ca0d"
import script from "./WorkoutTypes.vue?vue&type=script&lang=js"
export * from "./WorkoutTypes.vue?vue&type=script&lang=js"
import style0 from "./WorkoutTypes.vue?vue&type=style&index=0&id=0b21ca0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports